/**
 * config.js in a project to store configuration variables or settings that can be accessed 
 * throughout the application.
 * 
 * Constants defined here can be export(Good Practice- use named export) and,
 * named import in the files wherever they are needed. 
 * 
 * By using a config.js file, you can easily modify these settings 
 * without having to search through your codebase to find all the places where the values are used.
 */

//Config Driven UI - Mock Data from API
export const IMG_CDN = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";
export const IMG_CDN_Link = 'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/'


export const restaurantList = [
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "73011",
            name: "Dindigul Thalappakatti",
            uuid: "27ff4155-fe46-418e-9862-ab98953bf953",
            city: "22",
            area: "Anand Vihar Colony",
            totalRatingsString: "5000+ ratings",
            cloudinaryImageId: "w0fc1sr85flnqzb7qhma",
            cuisines: ["South Indian", "North Indian", "Snacks", "Biryani"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 31,
            maxDeliveryTime: 31,
            slaString: "31 MINS",
            lastMileTravel: 6.199999809265137,
            slugs: {
                restaurant: "kfc-chukkuwala-chukkuwala",
                city: "dehradun",
            },
            cityState: "22",
            address:
                "KFC Restaurant, Khasra No 1281/1291, Opp Dr Manish Jain hospital, Chakrata road, Dehradun-248001",
            locality: "Clock Tower",
            parentId: 547,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            ribbon: [
                {
                    type: "PROMOTED",
                },
            ],
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "cid=5698075~p=1~eid=00000185-8b09-7c92-0e51-a04b00dc0124",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "6.1 kms",
            hasSurge: false,
            sla: {
                restaurantId: "73011",
                deliveryTime: 31,
                minDeliveryTime: 31,
                maxDeliveryTime: 31,
                lastMileTravel: 6.199999809265137,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: true,
            avgRating: "4.0",
            totalRatings: 5000,
            new: false,
        },
        subtype: "basic",
    },
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "5421325",
            name: "Copper Kitchen",
            uuid: "f2ee37f5-9ab0-4903-9420-6cae020b0a38",
            city: "22",
            area: "Majra    Bansal Home",
            totalRatingsString: "50+ ratings",
            cloudinaryImageId: "ousftkkaojw0itx4u3tw",
            cuisines: ["North Indian", "South Indian", "Fast Food", "Snacks", "Beverages"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 33,
            minDeliveryTime: 33,
            maxDeliveryTime: 33,
            slaString: "33 MINS",
            lastMileTravel: 0.6000000238418579,
            slugs: {
                restaurant: "domnik-pizza-patel-nagar-patel-nagar-2",
                city: "dehradun",
            },
            cityState: "22",
            address:
                "28/3 Sewala Chandravani Road, Arcedia Grant, Dehradun Rural, Dehradun, Uttarakhand",
            locality: "Patel Nagar",
            parentId: 22321,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "0.6 kms",
            hasSurge: false,
            sla: {
                restaurantId: "542132",
                deliveryTime: 33,
                minDeliveryTime: 33,
                maxDeliveryTime: 33,
                lastMileTravel: 0.6000000238418579,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "2.8",
            totalRatings: 50,
            new: false,
        },
        subtype: "basic",
    },
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "3215170",
            name: "Banana Leaf",
            uuid: "899d5dd4-200a-48b2-a321-391bb9486ec2",
            city: "22",
            area: "Majra",
            totalRatingsString: "50+ ratings",
            cloudinaryImageId: "v7msadjrhhu6p1dbg29l",
            cuisines: ["Indian", "Chinese", "Tandoor", "Thalis", "Fast Food"],
            tags: [],
            costForTwo: 20000,
            costForTwoString: "₹200 FOR TWO",
            deliveryTime: 25,
            minDeliveryTime: 25,
            maxDeliveryTime: 25,
            slaString: "25 MINS",
            lastMileTravel: 0.699999988079071,
            slugs: {
                restaurant: "food-planet-restaurant-patel-nagar-patel-nagar",
                city: "dehradun",
            },
            cityState: "22",
            address:
                "157/11, Chandra Parisar Chandra Bani Rd, Ekta Enclave, Doon Enclave, Majra, Dehradun, Uttarakhand 248171",
            locality: "Patel Nagar",
            parentId: 81850,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "0.6 kms",
            hasSurge: false,
            sla: {
                restaurantId: "321517",
                deliveryTime: 25,
                minDeliveryTime: 25,
                maxDeliveryTime: 25,
                lastMileTravel: 0.699999988079071,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.8",
            totalRatings: 50,
            new: false,
        },
        subtype: "basic",
    },
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "311800",
            name: "Kati Roll Shop",
            uuid: "162a4dc4-50de-452a-82cf-751e18ac9952",
            city: "22",
            area: "Anand Vihar Colony",
            totalRatingsString: "5000+ ratings",
            cloudinaryImageId: "oy37srywtgi89uynbb4v",
            cuisines: ["North Indian", "Snacks"],
            tags: [],
            costForTwo: 35000,
            costForTwoString: "₹350 FOR TWO",
            deliveryTime: 39,
            minDeliveryTime: 39,
            maxDeliveryTime: 39,
            slaString: "39 MINS",
            lastMileTravel: 6.300000190734863,
            slugs: {
                restaurant: "burger-king-chakrata-road-ballupur",
                city: "dehradun",
            },
            cityState: "22",
            address:
                "5/5,4/4 & 3/3, GROUND FLOOR, CHAKRATA ROAD, DEHRADUN, UTTRAKHAND",
            locality: "CHAKRATA ROAD",
            parentId: 166,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "60% off",
                shortDescriptionList: [
                    {
                        meta: "60% off | Use STEALDEAL",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "60% off up to ₹120 | Use code STEALDEAL",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "60% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use STEALDEAL",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "60% off up to ₹120 | Use code STEALDEAL",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            ribbon: [
                {
                    type: "PROMOTED",
                },
            ],
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "cid=5700193~p=4~eid=00000185-8b09-7c92-0e51-a04c00dc0405",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "6.3 kms",
            hasSurge: false,
            sla: {
                restaurantId: "311806",
                deliveryTime: 39,
                minDeliveryTime: 39,
                maxDeliveryTime: 39,
                lastMileTravel: 6.300000190734863,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: true,
            avgRating: "4.2",
            totalRatings: 5000,
            new: false,
        },
        subtype: "basic",
    },
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "132460",
            name: "Annapurna Andhra Mess",
            uuid: "c6460418-904b-4371-9e04-0ce8b1b46cae",
            city: "22",
            area: "Dehradun",
            totalRatingsString: "1000+ ratings",
            cloudinaryImageId: "mnjmlphk3sefop8tzo5i",
            cuisines: ["South Indian", "Biryani", "North Indian"],
            tags: [],
            costForTwo: 20000,
            costForTwoString: "₹200 FOR TWO",
            deliveryTime: 25,
            minDeliveryTime: 25,
            maxDeliveryTime: 25,
            slaString: "25 MINS",
            lastMileTravel: 1.399999976158142,
            slugs: {
                restaurant: "annapurna-andhra-mess-subhash-nagar-subhash-nagar",
                city: "dehradun",
            },
            cityState: "22",
            address:
                "keshav enclave sewla khurd chandrabani road behind uttranchal PG college",
            locality: "Patel Nagar",
            parentId: 33997,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "1.3 kms",
            hasSurge: false,
            sla: {
                restaurantId: "132460",
                deliveryTime: 25,
                minDeliveryTime: 25,
                maxDeliveryTime: 25,
                lastMileTravel: 1.399999976158142,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "4.0",
            totalRatings: 1000,
            new: false,
        },
        subtype: "basic",
    },
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "196677",
            name: "Firangi Bake Shop",
            uuid: "e652ab57-22c2-4226-b5ea-a5caa26ee0f8",
            city: "22",
            area: "Patel Nagar",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "ivsvlekfebsbqmtmni3h",
            cuisines: ["North Indian", "Snacks", "Beverages", "Desserts"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 31,
            maxDeliveryTime: 31,
            slaString: "31 MINS",
            lastMileTravel: 0.800000011920929,
            slugs: {
                restaurant: "uncle-ji-restaurant-patel-nagar-patel-nagar",
                city: "dehradun",
            },
            cityState: "22",
            address: "348 santosh tower, majra road gram majra dehradun 248001",
            locality: "Patel Nagar",
            parentId: 298209,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "0.8 kms",
            hasSurge: false,
            sla: {
                restaurantId: "496677",
                deliveryTime: 31,
                minDeliveryTime: 31,
                maxDeliveryTime: 31,
                lastMileTravel: 0.800000011920929,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.2",
            totalRatings: 0,
            new: false,
        },
        subtype: "basic",
    },
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "296677",
            name: "Drunken Monkey",
            uuid: "e652ab57-22c2-4226-b5ea-a5caa26ee0f8",
            city: "22",
            area: "Patel Nagar",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "2d0c902eb2975b651d78e566bd8d06be",
            cuisines: ["Juices", "Snacks", "Beverages", "Desserts"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 31,
            maxDeliveryTime: 31,
            slaString: "31 MINS",
            lastMileTravel: 0.800000011920929,
            slugs: {
                restaurant: "uncle-ji-restaurant-patel-nagar-patel-nagar",
                city: "dehradun",
            },
            cityState: "22",
            address: "348 santosh tower, majra road gram majra dehradun 248001",
            locality: "Patel Nagar",
            parentId: 298209,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "0.8 kms",
            hasSurge: false,
            sla: {
                restaurantId: "496677",
                deliveryTime: 31,
                minDeliveryTime: 31,
                maxDeliveryTime: 31,
                lastMileTravel: 0.800000011920929,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "4.2",
            totalRatings: 0,
            new: false,
        },
        subtype: "basic",
    },
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "416677",
            name: "Sri Sampoorna Veg Restaurant",
            uuid: "e652ab57-22c2-4226-b5ea-a5caa26ee0f8",
            city: "22",
            area: "Patel Nagar",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "yv55fex41rwx0mtlt16q",
            cuisines: ["South Indian", "North Indian", "Snacks", "Beverages"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 31,
            maxDeliveryTime: 31,
            slaString: "31 MINS",
            lastMileTravel: 0.800000011920929,
            slugs: {
                restaurant: "uncle-ji-restaurant-patel-nagar-patel-nagar",
                city: "dehradun",
            },
            cityState: "22",
            address: "348 santosh tower, majra road gram majra dehradun 248001",
            locality: "Patel Nagar",
            parentId: 298209,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "0.8 kms",
            hasSurge: false,
            sla: {
                restaurantId: "496677",
                deliveryTime: 31,
                minDeliveryTime: 31,
                maxDeliveryTime: 31,
                lastMileTravel: 0.800000011920929,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "2.9",
            totalRatings: 0,
            new: false,
        },
        subtype: "basic",
    },
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "396677",
            name: "Silver Fish",
            uuid: "e652ab57-22c2-4226-b5ea-a5caa26ee0f8",
            city: "22",
            area: "Patel Nagar",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "ix9re2vh7mzu2bynrdhx",
            cuisines: ["South Indian", "Non Veg", "Snacks", "Beverages"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 31,
            maxDeliveryTime: 31,
            slaString: "31 MINS",
            lastMileTravel: 0.800000011920929,
            slugs: {
                restaurant: "uncle-ji-restaurant-patel-nagar-patel-nagar",
                city: "dehradun",
            },
            cityState: "22",
            address: "348 santosh tower, majra road gram majra dehradun 248001",
            locality: "Patel Nagar",
            parentId: 298209,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "0.8 kms",
            hasSurge: false,
            sla: {
                restaurantId: "496677",
                deliveryTime: 31,
                minDeliveryTime: 31,
                maxDeliveryTime: 31,
                lastMileTravel: 0.800000011920929,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "4.0",
            totalRatings: 0,
            new: false,
        },
        subtype: "basic",
    },
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "496077",
            name: "Udhayam Juice Shop",
            uuid: "e652ab57-22c2-4226-b5ea-a5caa26ee0f8",
            city: "22",
            area: "Patel Nagar",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "ox2wtrnxa7iakfefckoy",
            cuisines: ["South Indian", "North Indian", "Snacks", "Beverages"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 31,
            maxDeliveryTime: 31,
            slaString: "31 MINS",
            lastMileTravel: 0.800000011920929,
            slugs: {
                restaurant: "uncle-ji-restaurant-patel-nagar-patel-nagar",
                city: "dehradun",
            },
            cityState: "22",
            address: "348 santosh tower, majra road gram majra dehradun 248001",
            locality: "Patel Nagar",
            parentId: 298209,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "0.8 kms",
            hasSurge: false,
            sla: {
                restaurantId: "496677",
                deliveryTime: 31,
                minDeliveryTime: 31,
                maxDeliveryTime: 31,
                lastMileTravel: 0.800000011920929,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.4",
            totalRatings: 0,
            new: false,
        },
        subtype: "basic",
    },
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "4962677",
            name: "Writer's Cafe",
            uuid: "e652ab57-22c2-4226-b5ea-a5caa26ee0f8",
            city: "22",
            area: "Patel Nagar",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "njtmfslhi2dbosvnssar",
            cuisines: ["North Indian", "Snacks", "Beverages", "Desserts"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 31,
            maxDeliveryTime: 31,
            slaString: "31 MINS",
            lastMileTravel: 0.800000011920929,
            slugs: {
                restaurant: "uncle-ji-restaurant-patel-nagar-patel-nagar",
                city: "dehradun",
            },
            cityState: "22",
            address: "348 santosh tower, majra road gram majra dehradun 248001",
            locality: "Patel Nagar",
            parentId: 298209,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "0.8 kms",
            hasSurge: false,
            sla: {
                restaurantId: "496677",
                deliveryTime: 31,
                minDeliveryTime: 31,
                maxDeliveryTime: 31,
                lastMileTravel: 0.800000011920929,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "2.5",
            totalRatings: 0,
            new: false,
        },
        subtype: "basic",
    },
    {
        type: "restaurant",
        data: {
            type: "F",
            id: "4961677",
            name: "Paste Factory",
            uuid: "e652ab57-22c2-4226-b5ea-a5caa26ee0f8",
            city: "22",
            area: "Patel Nagar",
            totalRatingsString: "Too Few Ratings",
            cloudinaryImageId: "tqpyeoahq0hqfixzkrcm",
            cuisines: ["Desserts", "North Indian", "Snacks", "Beverages"],
            tags: [],
            costForTwo: 30000,
            costForTwoString: "₹300 FOR TWO",
            deliveryTime: 31,
            minDeliveryTime: 31,
            maxDeliveryTime: 31,
            slaString: "31 MINS",
            lastMileTravel: 0.800000011920929,
            slugs: {
                restaurant: "uncle-ji-restaurant-patel-nagar-patel-nagar",
                city: "dehradun",
            },
            cityState: "22",
            address: "348 santosh tower, majra road gram majra dehradun 248001",
            locality: "Patel Nagar",
            parentId: 298209,
            unserviceable: false,
            veg: false,
            select: false,
            favorite: false,
            tradeCampaignHeaders: [],
            aggregatedDiscountInfo: {
                header: "50% off",
                shortDescriptionList: [
                    {
                        meta: "50% off | Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            aggregatedDiscountInfoV2: {
                header: "50% OFF",
                shortDescriptionList: [
                    {
                        meta: "Use WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                descriptionList: [
                    {
                        meta: "50% off up to ₹100 | Use code WELCOME50",
                        discountType: "Percentage",
                        operationType: "RESTAURANT",
                    },
                ],
                subHeader: "",
                headerType: 0,
                superFreedel: "",
            },
            chain: [],
            feeDetails: {
                fees: [],
                totalFees: 0,
                message: "",
                title: "",
                amount: "",
                icon: "",
            },
            availability: {
                opened: true,
                nextOpenMessage: "",
                nextCloseMessage: "",
            },
            longDistanceEnabled: 0,
            rainMode: "NONE",
            thirdPartyAddress: false,
            thirdPartyVendor: "",
            adTrackingID: "",
            badges: {
                imageBased: [],
                textBased: [],
                textExtendedBadges: [],
            },
            lastMileTravelString: "0.8 kms",
            hasSurge: false,
            sla: {
                restaurantId: "496677",
                deliveryTime: 31,
                minDeliveryTime: 31,
                maxDeliveryTime: 31,
                lastMileTravel: 0.800000011920929,
                lastMileDistance: 0,
                serviceability: "SERVICEABLE",
                rainMode: "NONE",
                longDistance: "NOT_LONG_DISTANCE",
                preferentialService: false,
                iconType: "EMPTY",
            },
            promoted: false,
            avgRating: "3.7",
            totalRatings: 0,
            new: false,
        },
        subtype: "basic",
    }
    // {
    //     type: "restaurant",
    //     data: {
    //         type: "F",
    //         id: "496377",
    //         name: "Sweet Tooth",
    //         uuid: "e652ab57-22c2-4226-b5ea-a5caa26ee0f8",
    //         city: "22",
    //         area: "Patel Nagar",
    //         totalRatingsString: "Too Few Ratings",
    //         cloudinaryImageId: "7c51efd1c5a12b7925e428a87977f85d",
    //         cuisines: ["Cakes", "Snacks", "Desserts"],
    //         tags: [],
    //         costForTwo: 30000,
    //         costForTwoString: "₹300 FOR TWO",
    //         deliveryTime: 31,
    //         minDeliveryTime: 31,
    //         maxDeliveryTime: 31,
    //         slaString: "31 MINS",
    //         lastMileTravel: 0.800000011920929,
    //         slugs: {
    //             restaurant: "uncle-ji-restaurant-patel-nagar-patel-nagar",
    //             city: "dehradun",
    //         },
    //         cityState: "22",
    //         address: "348 santosh tower, majra road gram majra dehradun 248001",
    //         locality: "Patel Nagar",
    //         parentId: 298209,
    //         unserviceable: false,
    //         veg: false,
    //         select: false,
    //         favorite: false,
    //         tradeCampaignHeaders: [],
    //         aggregatedDiscountInfo: {
    //             header: "50% off",
    //             shortDescriptionList: [
    //                 {
    //                     meta: "50% off | Use WELCOME50",
    //                     discountType: "Percentage",
    //                     operationType: "RESTAURANT",
    //                 },
    //             ],
    //             descriptionList: [
    //                 {
    //                     meta: "50% off up to ₹100 | Use code WELCOME50",
    //                     discountType: "Percentage",
    //                     operationType: "RESTAURANT",
    //                 },
    //             ],
    //             subHeader: "",
    //             headerType: 0,
    //             superFreedel: "",
    //         },
    //         aggregatedDiscountInfoV2: {
    //             header: "50% OFF",
    //             shortDescriptionList: [
    //                 {
    //                     meta: "Use WELCOME50",
    //                     discountType: "Percentage",
    //                     operationType: "RESTAURANT",
    //                 },
    //             ],
    //             descriptionList: [
    //                 {
    //                     meta: "50% off up to ₹100 | Use code WELCOME50",
    //                     discountType: "Percentage",
    //                     operationType: "RESTAURANT",
    //                 },
    //             ],
    //             subHeader: "",
    //             headerType: 0,
    //             superFreedel: "",
    //         },
    //         chain: [],
    //         feeDetails: {
    //             fees: [],
    //             totalFees: 0,
    //             message: "",
    //             title: "",
    //             amount: "",
    //             icon: "",
    //         },
    //         availability: {
    //             opened: true,
    //             nextOpenMessage: "",
    //             nextCloseMessage: "",
    //         },
    //         longDistanceEnabled: 0,
    //         rainMode: "NONE",
    //         thirdPartyAddress: false,
    //         thirdPartyVendor: "",
    //         adTrackingID: "",
    //         badges: {
    //             imageBased: [],
    //             textBased: [],
    //             textExtendedBadges: [],
    //         },
    //         lastMileTravelString: "0.8 kms",
    //         hasSurge: false,
    //         sla: {
    //             restaurantId: "496677",
    //             deliveryTime: 31,
    //             minDeliveryTime: 31,
    //             maxDeliveryTime: 31,
    //             lastMileTravel: 0.800000011920929,
    //             lastMileDistance: 0,
    //             serviceability: "SERVICEABLE",
    //             rainMode: "NONE",
    //             longDistance: "NOT_LONG_DISTANCE",
    //             preferentialService: false,
    //             iconType: "EMPTY",
    //         },
    //         promoted: false,
    //         avgRating: "4.0",
    //         totalRatings: 0,
    //         new: false,
    //     },
    //     subtype: "basic",
    // }
];
